import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PaginationControlsComponent } from 'ngx-pagination';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { CreateNewCouponComponent } from './create-new-coupon/create-new-coupon.component';
import { ListCouponComponent } from './list-coupon/list-coupon.component';
import { CouponDetailsComponent } from './coupon-details/coupon-details.component';
import { UpdateCouponComponent } from './update-coupon/update-coupon.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { CouponBulkUploadPreviewComponent } from './coupon-bulk-upload-preview/coupon-bulk-upload-preview.component';

const routes: Routes = [
  // { path: 'create-coupon', component: CreateNewCouponComponent },
  { path: 'create-coupon', component: CreateNewCouponComponent },
  { path: 'list-coupon', component: ListCouponComponent },
  { path: 'coupon-details/:id', component: CouponDetailsComponent },
  { path: 'update-coupon/:id', component: UpdateCouponComponent },
  { path: 'bulk-upload-coupon', component: BulkUploadComponent },
  { path: 'preview-bulk-upload-coupon', component: CouponBulkUploadPreviewComponent },
];

@NgModule({
  declarations: [
    CreateNewCouponComponent,
    ListCouponComponent,
    CouponDetailsComponent,
    UpdateCouponComponent,
    BulkUploadComponent,
    CouponBulkUploadPreviewComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    RouterModule.forChild(routes),
    SharedModule,
    ReactiveFormsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CouponsectionModule { }
